import {GET_CATEGORY_LIST, GET_ACTIVE_CATEGORY,DELETE_CATEGORY,UPDATE_CATEGORY,GET_CATEGORY_LIST_ALL,GET_SERVICE_LIST,GET_SERVICE_INFO,
GET_CATEGORY_LIST_BY_TYPE, GET_SERVICE_LIST_POS, GET_PRODUCT_LIST_POS, GET_COMBO_LIST_POS, GET_ALL_CATEGORY_LIST, GET_GIFTCARD_LIST, GET_GIFTCARD_DETAIL, GET_COMBO_LIST_ACTIVE} from "./serviceListTypes";
import {GET_SERVICE_LIST_BY_CATEGORY, GET_FULL_CATEGORY_SERVICE_LIST} from './serviceListTypes'
import { Service } from "../../models/service";

export default {
    [GET_CATEGORY_LIST](state, data) {
      if(data.items && data.items.length) {
        for(let i = 0; i < data.items.length; i++) {
          if(data.items[i].type == 'gift_card' || data.items[i].type == 'custom') {
            data.items.splice(i, 1);
          }
        }
      }
      // console.log(data);
      state.categoryList = data;
    },
    [GET_ALL_CATEGORY_LIST](state, data) {
      state.allCategoryList = data;
    },
    [GET_CATEGORY_LIST_ALL](state, data) {
      state.categoryListAll = data;
    },
    [GET_SERVICE_LIST_BY_CATEGORY](state, data){
      state.serviceList = data
    },
    [GET_ACTIVE_CATEGORY](state, data){
      state.activeStaffData = data
    },
    [GET_SERVICE_INFO](state,data){
      state.service_info = data
    },
    [DELETE_CATEGORY](state, data){
      const ItemIndex = state.categoryList.findIndex((p) => p.id == data.id)
      state.categoryList.splice(ItemIndex, 1)
    },
    [UPDATE_CATEGORY](state ,data){
      const productIndex = state.categoryList.findIndex((p) => p.id == data.id)
      Object.assign(state.categoryList[productIndex], data)
    },
    [GET_SERVICE_LIST](state, data) {
      state.checkoutService = data;
    },
    [GET_SERVICE_LIST](state, data) {
      state.checkoutServiceData = data;
      let checkout = [];
      for(let i = 0; i < data.items.length; i++) {
        checkout.push(new Service(data.items[i]));
      }
      state.checkoutService = checkout;
    },
    [GET_CATEGORY_LIST_BY_TYPE](state, data) {
      state.categoryListByType = data;
    },
    [GET_SERVICE_LIST_POS](state, data) {
      state.serviceListByType = data;
    },
    [GET_PRODUCT_LIST_POS](state, data) {
      state.productListByType = data;
    },
    [GET_COMBO_LIST_POS](state, data) {
      state.comboListByType = data;
    },
    [GET_GIFTCARD_LIST](state, data) {
      state.giftCardData = data;
    },
    [GET_GIFTCARD_DETAIL](state, data) {
      state.giftCardDetail = data;
    },
    [GET_COMBO_LIST_ACTIVE](state, data) {
      state.comboListActive = data;
    },
    [GET_FULL_CATEGORY_SERVICE_LIST](state, data) {
      state.fullCategoryServiceList = data;
    }
  }
